import { StyledHeader } from "./headerStyles";
import Searcher from "./searcher";

function Header() {
    return (
        <StyledHeader>
            <Searcher/>
        </StyledHeader>
    )
}

export default Header;